import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";
import * as XLSX from "xlsx";
import { BASE_RESULT_HEADER_MAP, INPUT_LABEL_MAP } from "./aprAutoData";

export async function generateExcel(
  payload: any,
  filename: string = "std_pallet_racking_auto_results.xlsx",
): Promise<void> {
  try {
    const { constantInputs, top3Results } = payload;
    const wb = XLSX.utils.book_new();

    const resolvePath = (obj: any, path: string) => {
      return path.split(".").reduce((acc, part) => {
        if (!acc) return undefined;

        if (part.includes("[") && part.includes("]")) {
          const [name, indexPart] = part.split("[");
          const index = parseInt(indexPart.replace("]", ""), 10);
          return acc[name]?.[index];
        }

        return acc[part];
      }, obj);
    };

    const inputsSheet: any[][] = [];
    for (const [key, label] of Object.entries(INPUT_LABEL_MAP)) {
      inputsSheet.push([label, constantInputs[key] ?? ""]);
    }
    const wsInputs = XLSX.utils.aoa_to_sheet(inputsSheet);
    XLSX.utils.book_append_sheet(wb, wsInputs, "Inputs");

    const sheetData: any[][] = [];

    const activeHeaders = BASE_RESULT_HEADER_MAP.filter((h) =>
      h.condition(payload),
    );
    const headerLabels = activeHeaders.map((h) => h.label);

    top3Results.forEach((profileGroup: any, index: number) => {
      sheetData.push([
        `TOP OPTION ${index + 1}: ${profileGroup.label || "N/A"}`,
      ]);

      sheetData.push(headerLabels);

      if (profileGroup.combos && Array.isArray(profileGroup.combos)) {
        profileGroup.combos.forEach((combo: any) => {
          const row = activeHeaders.map((header) => {
            const value = combo[header.key] ?? resolvePath(combo, header.key);

            if (Array.isArray(value)) return value.join("; ");

            return value === undefined || value === null ? "" : String(value);
          });
          sheetData.push(row);
        });
      }

      sheetData.push([]);
    });

    const wsResults = XLSX.utils.aoa_to_sheet(sheetData);

    wsResults["!cols"] = headerLabels.map(() => ({ wch: 20 }));

    XLSX.utils.book_append_sheet(wb, wsResults, "Top 3 Uprights");

    if (Capacitor.isNativePlatform()) {
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "base64" });

      const uniqueFileName = `${Date.now()}_${filename}`;
      const savedFile = await Filesystem.writeFile({
        path: uniqueFileName,
        data: wbout,
        directory: Directory.Cache,
      });

      await Share.share({
        title: "Export Excel",
        text: "Sharing your results",
        url: savedFile.uri,
        dialogTitle: "Share Excel File",
      });
    } else {
      XLSX.writeFile(wb, filename);
    }
  } catch (err) {
    throw err;
  }
}
